import { Checkbox, CheckboxAsPressable, CheckboxTypes, VStack, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Text } from 'native-base';
import React from 'react';

export declare namespace BooleanTypes {
  type SelectionProps = string[];

  type SelectionChange = (
    selections: SelectionProps,
    fieldName: string,
    filterIndex: number
  ) => void;

  interface Props {
    type: 'boolean';
    fieldName: string;
    filterIndex: number;
    title: string;
    options: [CheckboxTypes.Option] | [CheckboxTypes.Option, CheckboxTypes.Option];
    onSelectionChange: SelectionChange;
    selection?: SelectionProps;
    optionsColumns?: number;
    optionWidth?: CheckboxTypes.Props['optionWidth'];
  }
}

export const hasBooleanSelection = (selection: CheckboxTypes.Option['value'][]) =>
  !!selection.length;

export const BooleanFilter: React.FC<BooleanTypes.Props> = ({
  title,
  options,
  fieldName,
  filterIndex,
  onSelectionChange,
  selection,
  optionsColumns = 2,
  optionWidth = 150,
}) => {
  const [selections, setSelections] = React.useState<CheckboxTypes.Option['value'][]>(
    selection || []
  );

  const handleSelection = (value: string, selected: boolean) => {
    let newSelections: string[] = [];
    if (options.length === 1) {
      newSelections = selected ? [value] : [];
    } else {
      newSelections = [value];
    }
    setSelections(newSelections);
    onSelectionChange(newSelections, fieldName, filterIndex);
  };

  const selectionItems = useBreakpointValue({
    base: (
      <CheckboxAsPressable
        testID="primary-checkbox-as-pressable"
        options={options}
        selections={selections}
        onPress={handleSelection}
      />
    ),
    lg: (
      <HStack space={Spacing['inline.nano']}>
        <Checkbox
          selectedValues={selections}
          onChange={handleSelection}
          testId="primary-checkbox"
          options={options}
          vertical
          columns={optionsColumns}
          optionWidth={optionWidth}
        />
      </HStack>
    ),
  });

  if (!options.length) {
    return <></>;
  }

  return (
    <VStack space={Spacing['inline.xxxs']}>
      <Text variant="semibold" fontSize={Typography['fontsize.md']} lineHeight="distant">
        {title}
      </Text>
      {selectionItems}
    </VStack>
  );
};
